<ll-toolnavbar>
    <banner-toolnavbar></banner-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Banners</ll-titulo>

<banners listRoute="banners"></banners>
